// pages/Edit.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IEquipmentGroup from '../interfaces/IEquipmentGroup';

export default function Edit() {
  const { register, handleSubmit, control, setValue: setFormValue, getValues } = useForm<IEquipmentGroup>();
  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
  ];

  return (
    <CrudEdit
      model={'equipment-group'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={'Equipment group successfully updated!'}
      title={'Edit equipment group'}
      getValues={getValues}
    />
  );
}